package org.lennycodes.hldi.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.dom.svg.Text
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.icons.fa.FaEnvelope
import com.varabyte.kobweb.silk.components.icons.fa.FaFacebook
import com.varabyte.kobweb.silk.components.icons.fa.FaInstagram
import com.varabyte.kobweb.silk.components.icons.fa.IconCategory
import org.jetbrains.compose.web.attributes.ATarget
import org.jetbrains.compose.web.attributes.target
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.Text
import org.lennycodes.hldi.constants.HLDITheme




@Composable
fun SocialButton(
    text: String,
    link: String
) {

    A(
        href = link,
        attrs = Modifier
            .padding(6.px, 10.px)
            .borderRadius(topLeft = 6.px, topRight = 6.px)
            .backgroundColor(HLDITheme.Colors.primary)
            .color(HLDITheme.Colors.white)
            .fontSize(12.px)
            .display(org.jetbrains.compose.web.css.DisplayStyle.Flex)
            .styleModifier {
                property("align-items", "center")
                property("gap", "6px")
            }
            .textDecorationLine(TextDecorationLine.None)
            .toAttrs {
                target(ATarget.Blank)
            }
    ) {

        when (text) {

            "Email" -> FaEnvelope()

            "Facebook" -> FaFacebook()

            "Instagram" -> FaInstagram()

            else -> {}

        }


    }

}